import React from 'react';
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Button,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import LandingPageNav from '../../components/landingpage/LandingPageNav';
import Footer from '../../components/Footer/footer';

export default function PurchasePage() {
  const [expanded, setExpanded] = React.useState('step1');
  const brandGold = '#b79a59'; // tweak to match your design tokens

  const handleChange = (panel) => (_e, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const heroImg = 'https://res.cloudinary.com/ddhrdxc7d/image/upload/v1763994301/Blog_Landing_Page_Website_Header_-_Purchase_elhso1.jpg'; // TODO: replace with your asset

  const StepHeading = ({ n, title }) => (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      <Box
        aria-hidden
        sx={{
          width: 28,
          height: 28,
          borderRadius: '50%',
          border: `2px solid ${brandGold}`,
          color: brandGold,
          display: 'grid',
          placeItems: 'center',
          fontWeight: 700,
          fontSize: 14,
        }}
      >
        {n}
      </Box>
      <Typography component="span" sx={{ fontWeight: 700, fontSize: { xs: 18, sm: 20 }, color: 'text.primary' }}>
        {title}
      </Typography>
    </Box>
  );

  return (
    <>
      <LandingPageNav />
      {/* clear fixed AppBar height */}
      <Box sx={(theme) => ({ ...theme.mixins.toolbar })} />

      {/* HERO */}
<Box
  sx={(theme) => ({
    position: 'relative',
    width: '100%',
    overflowX: 'hidden',
    backgroundImage: `url(${heroImg})`,
    backgroundSize: 'cover',
    backgroundPosition: 'center top',
    minHeight: { xs: '55vh', md: '70vh' },
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
  })}
>
  <Box
    sx={{
      position: 'relative',
      zIndex: 2,
      ml: { xs: 2, sm: 4, md: 6 }, // ← EXACT MATCH TO HOME PAGE
      maxWidth: 600,
    }}
  >
    <Typography variant="h2" sx={{ color: '#fff', fontWeight: 800 }}>
      Purchase
    </Typography>

    <Typography
      variant="h5"
      sx={{
        color: '#fff',
        fontWeight: 400,
        mt: 1.5,
        maxWidth: 600,
      }}
    >
      A place to call your own
    </Typography>
  </Box>
</Box>


      

      <Container maxWidth="lg" sx={{ py: { xs: 5, md: 8 } }}>
        <Grid container spacing={6}>
          <Grid item xs={12} md={8}>
            <Typography variant="h4" component="h1" sx={{ fontWeight: 800, mb: 2 }}>
              Ready to Purchase Your Home?
            </Typography>
            <Typography variant="body1" sx={{ color: 'text.secondary', mb: 4 }}>
              We’re here to help you purchase the home of your dreams. Buying a home is one of the most exciting decisions you will
              make. From getting pre-approved to finding the perfect home, understanding the home buying process can help give you
              peace of mind. So can partnering with a mortgage lender you can trust. Whether you’re building or buying your home,
              Jet HomeLoans is here to help you along the way!
            </Typography>

            {/* Step 1 */}
            <Accordion
              elevation={0}
              expanded={expanded === 'step1'}
              onChange={handleChange('step1')}
              sx={{ borderTop: '1px solid', borderColor: 'divider' }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step1-content" id="step1-header">
                <StepHeading n={1} title="Get Pre-Approved" />
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ color: 'text.secondary', mb: 2 }}>
                  The first step is getting pre-approved. Pre-approval for your home loan considers your household income and payment
                  history before determining how much of a loan you qualify for. Online pre-approval applications like ours have become a
                  simple and secure way to qualify.
                </Typography>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  Home buyers can qualify for a variety of loan programs, and the best program for your neighbor may be different than
                  the one that’s right for you. Choosing the loan that’s best for you takes time, knowledge, and experience.
                </Typography>
                <Box sx={{ mt: 2 }}>
                  <Button
                    variant="contained"
                    component="a"
                    href="https://digitalmortgage.candidcrm.com/Jet-HomeLoans/005fI000000hPWDQAW&00DfI000004W7UeUAF"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ bgcolor: brandGold, '&:hover': { bgcolor: '#a2874b' } }}
                  >
                    Start Pre-Approval
                  </Button>
                </Box>
              </AccordionDetails>
            </Accordion>

            {/* Step 2 */}
            <Accordion
              elevation={0}
              expanded={expanded === 'step2'}
              onChange={handleChange('step2')}
              sx={{ borderTop: '1px solid', borderColor: 'divider' }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step2-content" id="step2-header">
                <StepHeading n={2} title="Find Your Home" />
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  Once you’ve been pre-approved for your loan, it’s time to find your dream home! Your new home consultant will guide you
                  throughout your homebuying process and help you find the perfect home for you.
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* Step 3 */}
            <Accordion
              elevation={0}
              expanded={expanded === 'step3'}
              onChange={handleChange('step3')}
              sx={{ borderTop: '1px solid', borderColor: 'divider' }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step3-content" id="step3-header">
                <StepHeading n={3} title="Loan Process" />
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  When you’ve found your dream home, it’s time for Jet HomeLoans to get to work! Your loan application is reviewed to
                  make sure all the required documents for your loan are in. You may need to provide additional documentation, so it’s a
                  good idea to keep a folder of all your files together. Creating a smooth process will help your loan paperwork flow more
                  efficiently, bringing you closer to closing day!
                </Typography>
              </AccordionDetails>
            </Accordion>

            {/* Step 4 */}
            <Accordion
              elevation={0}
              expanded={expanded === 'step4'}
              onChange={handleChange('step4')}
              sx={{ borderTop: '1px solid', borderColor: 'divider', borderBottom: '1px solid', mb: 2 }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="step4-content" id="step4-header">
                <StepHeading n={4} title="Welcome Home" />
              </AccordionSummary>
              <AccordionDetails>
                <Typography variant="body1" sx={{ color: 'text.secondary' }}>
                  You’re almost there! Once your home and loan are ready, Jet HomeLoans provides you with all the final details you need,
                  like your final closing disclosure, what to bring to your closing, and the funds needed at closing. All that’s left is
                  signing the final loan documents and receiving the keys to your house. Welcome home!
                </Typography>
              </AccordionDetails>
            </Accordion>
          </Grid>

          {/* Right rail card */}
          <Grid item xs={12} md={4}>
            <Card elevation={2} sx={{ borderRadius: 2, p: 0 }}>
              <CardContent sx={{ textAlign: 'center', p: { xs: 3, sm: 4 } }}>
                <Typography variant="h5" sx={{ fontWeight: 800, mb: 1 }}>
                  Mortgage Resources
                </Typography>
                <Typography variant="body2" sx={{ color: 'text.secondary', mb: 2 }}>
                  Learn more about mortgages, loan programs, and the loan process on our Mortgage Resources page.
                </Typography>
                <Button
                  variant="outlined"
                  href="/loan-programs"
                  sx={{
                    borderColor: brandGold,
                    color: brandGold,
                    '&:hover': { borderColor: brandGold, bgcolor: 'rgba(183,154,89,0.08)' },
                  }}
                >
                  Explore Resources
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Container>

      <Footer />
    </>
  );
}
